import { create } from 'zustand';

interface UpdateState {
  isUpdateAvailable: boolean;
  isForceUpdate: boolean;
  latestVersion: string | null;
  downloadUrl: string | null;
  applyUpdateHeaders: (headers: Record<string, string> | undefined) => void;
}

/**
 * Session-only signal derived from hoopla-vendor's `X-App-Update-*` response
 * headers (see the shared platform contract). Every response — success or
 * error — runs through `applyUpdateHeaders` in the apiClient interceptor, so
 * this store always reflects the latest server verdict. Not persisted: a
 * stale "update available" flag surviving a reload would be misleading once
 * the packaged app has actually restarted on the new build.
 */
export const useUpdateStore = create<UpdateState>((set) => ({
  isUpdateAvailable: false,
  isForceUpdate: false,
  latestVersion: null,
  downloadUrl: null,
  applyUpdateHeaders: (headers) => {
    const available = headers?.['x-app-update-available'] === 'true';
    if (!available) {
      set({ isUpdateAvailable: false, isForceUpdate: false, latestVersion: null, downloadUrl: null });
      return;
    }
    set({
      isUpdateAvailable: true,
      isForceUpdate: headers?.['x-app-update-force'] === 'true',
      latestVersion: headers?.['x-app-update-version'] ?? null,
      downloadUrl: headers?.['x-app-update-url'] ?? null,
    });
  },
}));
